<template>
    <td-dialog
        :title="title"
        v-if="dialogAboutVisible"
        :before-close="aboutDialogClose"
        :visible.sync="dialogAboutVisible"
        width="650px"
        :close-on-click-modal="true"
        :close-on-press-escape="false"
        top="18vh"
        @cancel="aboutDialogClose"
    >
        <el-main>
            <div style="display:inline-block;" v-if="systemVersion">
                <el-row style="font-size: 19px;margin-top:10px;bold ">
                    <b> {{ systemName }}</b>
                </el-row>
                <el-row> {{ this.vm.$t('common.MODULE_VERSION') }}:&nbsp;&nbsp;{{ systemVersion }} </el-row>
            </div>
            <el-main style="padding:0px" v-if="showModule">
                <el-divider style="margin-top:10px !important" v-if="showModule && systemVersion"></el-divider>
                <el-row>
                    <b
                        ><span style="padding-left:20px;font-size:17px" v-if="showModule">{{ this.vm.$t('common.PLUGIN_MOUDLE_INFO') }}</span></b
                    >
                </el-row>
                <el-row>
                    <td-table
                        :border="false"
                        :height="height"
                        :dataSource="tableData"
                        :columns="columns"
                        :hasMutiSelect="false"
                        :hasIndex="false"
                        :hasPage="false"
                        rowKey="sid"
                        :stripe="false"
                    ></td-table>
                </el-row>
                <el-row>
                    <el-divider v-if="showCustomModule"></el-divider>
                </el-row>
                <el-row>
                    <b>
                        <span style="padding-left:20px;font-size:17px" v-if="showCustomModule">{{ this.vm.$t('common.OTHER_INFO') }}</span></b
                    >
                </el-row>
                <el-row style="padding-left:20px" v-for="(custom, index) in customData" :key="index">
                    <div v-html="custom">{{ custom }}</div>
                </el-row>
            </el-main>
        </el-main>
    </td-dialog>
</template>

<script>
export default {
    data() {
        return {
            vm: window.vue,
            token: sessionStorage.getItem('token'),
            showModule: true,
            showCustomModule: false,
            height: 0,
            systemInfo: [],
            tableData: [],
            customData: [],
            columns: [
                {
                    label: 'common.MODULE_NAME',

                    prop: 'moduleCaption'
                },
                {
                    label: 'common.MODULE_VERSION',
                    prop: 'version'
                }
            ],
            dialogAboutVisible: false
        };
    },
    computed: {
        systemVersion: function() {
            return window.app.systemVersion;
        },
        systemName: function() {
            return window.app.homePageTitle;
        }
    },
    methods: {
        initData(title) {
            this.title = title;
            this.dialogAboutVisible = true;
            this.queryModuleInfo();
        },
        queryModuleInfo() {
            let _this = this;
            this.$api.listModuleInfo({}, response => {
                if (response.status !== _this.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                    return;
                }
                _this.customData = response.data.content.customList;
                if (_this.customData.length > 0) {
                    _this.showCustomModule = true;
                }
                _this.tableData = response.data.content.standardList;
                if (_this.tableData.length == 0) {
                    _this.showModule = false;
                    return;
                }
                _this.height = _this.tableData.length > 10 ? 200 : 40 + _this.tableData.length * 10;
            });
        },
        aboutDialogClose() {
            this.dialogAboutVisible = false;
        }
    }
};
</script>

<style scoped>
.top_title_center_logo {
    background-repeat: no-repeat;
    background-position: center;
    width: 100px;
    height: 60px;
}
</style>
